import React, { useState } from 'react';
import {ChevronDown, Target, Users, BookOpen, Lightbulb, TrendingUp, FlaskConical, Rocket, Shield, Globe, Network} from 'lucide-react';

const ObjectivesAccordion = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const objectives = [
        { icon: Users, title: 'AI Education & Training', desc: 'Develop internationally competitive AI education and professional training programmes that build a generation of skilled African AI practitioners.' },
        { icon: FlaskConical, title: 'Multidisciplinary Research', desc: 'Conduct multidisciplinary AI research addressing national and regional development priorities using open science principles.' },
        { icon: Shield, title: 'Policy, Governance & Ethics', desc: 'Support AI policy development, governance, ethics, and regulatory capacity for safe, inclusive, and accountable AI adoption across Africa.' },
        { icon: BookOpen, title: 'Open Science & FAIR Data', desc: 'Promote Open Science, FAIR data principles (Findable, Accessible, Interoperable, Reusable), and trusted research environments for African scientists.' },
        { icon: Lightbulb, title: 'University–Industry–Government Collaboration', desc: 'Strengthen three-way collaboration between universities, industry, and government to drive AI innovation ecosystems across Kenya and Africa.' },
        { icon: Rocket, title: 'AI Startup Incubation', desc: 'Incubate AI startups and facilitate the commercialization of AI technologies to foster sustainable, locally-owned innovation ecosystems.' },
        { icon: Globe, title: 'Regional AI Partnerships', desc: 'Build regional partnerships for AI knowledge exchange and collaborative research, connecting African institutions across the continent.' },
        { icon: Network, title: 'Global AICDN Engagement', desc: 'Mobilize international partnerships, research grants, technology transfer opportunities, and investment through the UN-supported AI Capacity Development Network (AICDN).' }
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="bg-gradient-to-br from-gray-50 to-blue-50 py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                        Our Objectives
                    </h2>
                    <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                        Comprehensive approach to building AI capacity across Africa
                    </p>
                </div>

                <div className="space-y-4">
                    {objectives.map((obj, idx) => {
                        const isActive = activeIndex === idx;
                        const Icon = obj.icon;

                        return (
                            <div
                                key={idx}
                                className={`bg-white rounded-2xl overflow-hidden transition-all duration-300 border-2 ${
                                    isActive
                                        ? 'border-blue-500 shadow-xl shadow-blue-100'
                                        : 'border-gray-200 hover:border-blue-300 shadow-sm hover:shadow-md'
                                }`}
                            >
                                <button
                                    onClick={() => toggleAccordion(idx)}
                                    className="w-full px-6 py-5 flex items-center justify-between text-left transition-colors duration-200 hover:bg-gray-50"
                                >
                                    <div className="flex items-center gap-4 flex-1">
                                        <div className={`rounded-xl w-12 h-12 flex items-center justify-center transition-all duration-300 ${
                                            isActive
                                                ? 'bg-transparent scale-110'
                                                : 'bg-transparent'
                                        }`}>
                                            <Icon className="w-6 h-6 text-blue-700" />
                                        </div>

                                        <div className="flex-1">
                                            <h4 className={`text-lg font-semibold transition-colors duration-200 ${
                                                isActive ? 'text-blue-600' : 'text-gray-900'
                                            }`}>
                                                {obj.title}
                                            </h4>
                                            {/* Show description preview on mobile when collapsed */}
                                            <p className={`text-sm text-gray-500 mt-1 md:hidden ${isActive ? 'hidden' : 'line-clamp-1'}`}>
                                                {obj.desc}
                                            </p>
                                        </div>
                                    </div>

                                    <ChevronDown
                                        className={`w-5 h-5 text-gray-400 transition-transform duration-300 flex-shrink-0 ml-4 ${
                                            isActive ? 'rotate-180 text-blue-500' : ''
                                        }`}
                                    />
                                </button>

                                <div
                                    className={`overflow-hidden transition-all duration-300 ${
                                        isActive ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                                    }`}
                                >
                                    <div className="px-6 pb-6 pt-2">
                                        <div className="pl-16">
                                            <div className="border-l-4 border-blue-200 pl-4 py-2">
                                                <p className="text-gray-700 leading-relaxed">
                                                    {obj.desc}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

            </div>
        </div>
    );
};

export default ObjectivesAccordion;